"use client";

// Error boundary del root del App Router. Atrapa cualquier error tirado durante
// render de un segmento — server-side incluido, viene desofuscado vía `digest`.
// Next pasa `error.digest` (id estable) para correlacionar con los logs server.

import { useEffect } from "react";
import { ErrorState } from "@/components/ui/error-state";
import { captureError } from "@/lib/observability";

export default function GlobalRouteError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // PostHog client tiene `capture_exceptions: true`, así que es probable que
    // el error ya esté reportado por la captura automática. Esto agrega el
    // digest (id de Next) como tag para que el dashboard los correlacione.
    void captureError(error, {
      source: "boundary.app_root",
      tags: { digest: error.digest, error_code: "internal" },
    });
  }, [error]);

  return (
    <div className="flex min-h-[60vh] items-center justify-center p-6">
      <ErrorState
        reportId={error.digest ?? null}
        onReset={reset}
        homeHref="/"
      />
    </div>
  );
}
